var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: ["list-row", _vm.layout] },
    [
      _c("i", { class: [_vm.icon, "icon", _vm.fontSize] }),
      _vm._v(" "),
      _c("paragraph", { attrs: { type: "p", variation: _vm.fontSize } }, [
        _vm._v("\n        " + _vm._s(_vm.text) + "\n    "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }